export const nulinga = {
  linkRef: 'https://nulinga.com/postulantes/new?token=qe6j',
}
